import { TextField } from '@material-ui/core';
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import CustomSelectBox from '../../components/CustomSelectBox/CustomSelectBox';
import { fetchAllProduct, resetEdit, updateProduct } from '../../redux/features/product.features';
import LoadingScreen from '../LoadingScreen/LoadingScreen';
import './priceUpdate.css'
const initialValue = {
    buyCurrency: "LKR",
    buyPrice: "0.00",
    sellPriceLocal: "0.00",
    sellLocalCurrency: "LKR",
    sellForeignersCurrency: "USD",
    sellPriceForeigners:"0.00",
}
const ItemPriceUpdate = () => {
    const dispatch = useDispatch();
    const [values, setValues]= useState(initialValue)
    const [searchValue, setSearchValue]= useState("")
    let productState = useSelector((state) => {
        return state.productReducer;
      });
  let { products,editProduct } = productState;
  let { loading, errorMessage, successMessage } = editProduct;

  useEffect(()=>{
    dispatch(fetchAllProduct())
  },[dispatch])


const handleChange = (e)=>{
    const {name, value}= e.target;
    setValues({
        ...values,
        [name]:value
    })

}
    const searchItem = ()=>{
        console.log(products)
        if(products.filter(x=>Number(x.productId) === Number(searchValue)).length === 0 ) return alert("Item not found, please enter correct item id")
        const item = products.filter(x=>Number(x.productId) === Number(searchValue))[0]
        const finalValues = {
             
            _id: item.id,
            buyCurrency: item.buyCurrency === "" ? "LKR" : item.buyCurrency,
            buyPrice: item.buyPrice,
            sellPriceLocal: item.sellPriceLocal,
            sellLocalCurrency:
              item.sellLocalCurrency === "" ? "LKR" : item.sellLocalCurrency,
            sellForeignersCurrency:
              item.sellForeignersCurrency === ""
                ? "USD"
                : item.sellForeignersCurrency,
            sellPriceForeigners: item.sellPriceForeigners,
          };
          console.log("Price update Verify Data : ", finalValues);
          setValues(finalValues)
           
    }
    const updatePrice = ()=>{

        if(searchValue === "" ) return alert("Item not found, please enter correct item id")
        const finalValues = {
            _id:values._id,
            buyCurrency: values.buyCurrency === "" ? "LKR" : values.buyCurrency,
            buyPrice: values.buyPrice,
            sellPriceLocal: values.sellPriceLocal,
            sellLocalCurrency:
              values.sellLocalCurrency === "" ? "LKR" : values.sellLocalCurrency,
            sellForeignersCurrency:
              values.sellForeignersCurrency === ""
                ? "USD"
                : values.sellForeignersCurrency,
            sellPriceForeigners: values.sellPriceForeigners,
          };
          console.log("Price update Verify Data : ", finalValues);
        //   setValues(finalValues)
        dispatch(updateProduct([values]));
           
    }




  return (
    <div className='flex flex-col w-full'>
        <div className="flex items-center">
            <div className="p-4">
                <TextField
                label="Enter item id"
                placeholder='Enter item id'
                value={searchValue}
                type="number"
                onChange={(e)=>setSearchValue(e.target.value)}
                />
            </div>
            <div onClick={()=>{searchItem()}} style={{background:'var(--main-color)'}} className="m-2 p-4 font-extrabold text-white uppercase cursor-pointer">Search</div>
        </div>
        <hr></hr>
        {successMessage !== "" || errorMessage !== "" ? (
        <LoadingScreen 
          close={true}
          hideContinue={true}
         
          loading={loading}
           
          onClose={() => {
            dispatch(resetEdit());
             
          }}
          errorMessage={errorMessage}
          successMessage={successMessage}
        />
      ) : (
        <div className="p-5 flex flex-col w-full">
            <div className="flex">
            <div className="flex w-full ">
        <div className="flex  w-full justify-between items-center">
          <TextField
            style={{ color: "white" }}
            className=""
            required
            type="number"
            id="outlined-required"
            label="Buy Price"
            placeholder="999,999,999.00"
            defaultValue=""
            value={values.buyPrice}
            name="buyPrice"
            color="warning"
            onChange={handleChange}
          />

          <CustomSelectBox
            style={{ width: "122px" }}
            className=""
            items={["LKR", "USD"]}
            onChange={handleChange}
            title="Buy Currency"
            name="buyCurrency"
            value={values.buyCurrency}
            selectedValue={values.buyCurrency}
          />
        </div>

        <div className="flex  w-full justify-between items-center">
          <TextField
            style={{ color: "white" }}
            className=""
            required
            type="number"
            id="outlined-required"
            label="Amount planned to sell (foreign) "
            placeholder="999,999,999.00"
            defaultValue=""
            value={values.sellPriceForeigners}
            onChange={handleChange}
            name="sellPriceForeigners"
            color="warning"
          />

          <CustomSelectBox
            style={{ width: "122px" }}
            className=""
            items={["LKR", "USD"]}
            onChange={handleChange}
            title="Currency"
            name="sellForeignersCurrency"
            value={values.sellForeignersCurrency}
          />
        </div>
        <div className="flex  w-full justify-between items-center">
          <TextField
            style={{ color: "white" }}
            className=""
            required
            id="outlined-required"
            label="Amount planned to sell (local) "
            placeholder="999,999,999.00"
            defaultValue=""
            type="number"
            value={values.sellPriceLocal}
            onChange={handleChange}
            name="sellPriceLocal"
            color="warning"
          />

          <CustomSelectBox
            style={{ width: "122px" }}
            className=""
            items={["LKR", "USD"]}
            onChange={handleChange}
            title="Currency"
            name="sellLocalCurrency"
            value={values.sellLocalCurrency}
          />
        </div>
      </div>
            </div>
            <div className="flex justify-end">
            <div   className="red-button p-4 font-extrabold text-white uppercase cursor-pointer">Clear</div>
            <div  onClick={()=>{updatePrice()}} className="green-button p-4 font-extrabold text-white uppercase cursor-pointer">Update</div>

            </div>
        </div>)
}
    </div>
  )
}

export default ItemPriceUpdate